import { ConfigProvider, App as AntdApp } from 'antd'
import viVN from 'antd/locale/vi_VN'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import { tacticalTheme } from '@/shared/theme'
import type { ReactNode } from 'react'

dayjs.locale('vi')

interface AppProvidersProps {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ConfigProvider theme={tacticalTheme} locale={viVN}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  )
}
